module.exports = __webpack_public_path__ + "img/whptback.b775c629.png";